import { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * Returns the current app the user is in (Admin console or NLC)
 * based on the current route (either admin or learning-center)
 *
 * @returns {string}
 */
const useCurrentApp = () => {
  const [currentApp, setCurrentApp] = useState(null);
  const { pathname } = useLocation();

  useEffect(() => {
    setCurrentApp(pathname.split("/")[1]);
  }, [pathname]);

  return currentApp;
};

export default useCurrentApp;
